<ng-container *ngIf="error as errorMsg; else resultTemplate">
  <em-error-result [subTitle]="errorMsg"></em-error-result>
</ng-container>

<ng-template #resultTemplate>
  <nz-row nzAlign="middle" nzJustify="space-between" class="em-area">
    <nz-col nzSpan="24">
      <nz-card>
        <nz-skeleton [nzActive]="true" [nzLoading]="loading" [nzParagraph]="{ rows: 1 }">
          <nz-descriptions nzSize="small" nzLayout="vertical">
            <nz-descriptions-item nzTitle="Design Usability">
              {{ design?.usability }}
              <span *ngIf="!!design?.usabilityText">({{ design?.usabilityText }})</span>
            </nz-descriptions-item>
            <nz-descriptions-item nzTitle="Element review done">
              <i
                nz-icon
                [nzType]="design?.qa20Check ? 'check-circle' : 'close-circle'"
                nzTheme="twotone"
                [nzTwotoneColor]="design?.qa20Check ? '#52c41a' : 'red'"
              ></i>
            </nz-descriptions-item>
            <nz-descriptions-item
              nzTitle="Main Connectors"
              *emVisibleForRoles="['Front End', 'Novelty', 'Reorder', 'Mould Engineering']"
            >
              <em-connector></em-connector>
            </nz-descriptions-item>
          </nz-descriptions>
        </nz-skeleton>
      </nz-card>
    </nz-col>
  </nz-row>

  <nz-row
    class="em-area"
    *emVisibleForRoles="['Front End', 'Novelty', 'Re-Engineering', 'Reorder']"
  >
    <nz-col [nzSpan]="24">
      <em-element-risk-assessment></em-element-risk-assessment>
    </nz-col>
  </nz-row>
  <nz-row class="em-area" *emVisibleForRoles="['Reorder', 'Front End']">
    <nz-col [nzSpan]="24">
      <em-processing-history-document-link></em-processing-history-document-link>
    </nz-col>
  </nz-row>
  <nz-row
    class="em-area"
    *emVisibleForRoles="['Front End', 'Novelty', 'Re-Engineering', 'Reorder']"
  >
    <nz-col [nzSpan]="24">
      <em-toy-safety-report></em-toy-safety-report>
    </nz-col>
  </nz-row>
  <nz-row class="em-area" *emVisibleForRoles="['Re-Engineering', 'Front End']">
    <nz-col [nzSpan]="24">
      <em-item-log></em-item-log>
    </nz-col>
  </nz-row>
  <nz-row class="em-area">
    <nz-col [nzSpan]="24">
      <em-mould-log></em-mould-log>
    </nz-col>
  </nz-row>
  <nz-row class="em-area">
    <nz-col [nzSpan]="24">
      <em-construction-log></em-construction-log>
    </nz-col>
  </nz-row>
  <nz-row class="em-area" *emVisibleForRoles="['Re-Engineering', 'Reorder', 'Front End']">
    <nz-col [nzSpan]="24">
      <em-info-codes></em-info-codes>
    </nz-col>
  </nz-row>
</ng-template>
